module.exports = __webpack_public_path__ + "img/urenregistratie-icon.b0a6873.png";